/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Search_SeniorityInputs */

const en_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seniority`)
};

const de_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erfahrungsstufe`)
};

const fr_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niveau d'expérience`)
};

const es_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nivel de experiencia`)
};

const it_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esperienza`)
};

const nl_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioriteit`)
};

const pl_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poziom doświadczenia`)
};

const fi_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kokemus­taso`)
};

const da_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioritet`)
};

const sv_salary_search_seniority = /** @type {(inputs: Salary_Search_SeniorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senioritet`)
};

/**
* | output |
* | --- |
* | "Seniority" |
*
* @param {Salary_Search_SeniorityInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_search_seniority = /** @type {((inputs?: Salary_Search_SeniorityInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Search_SeniorityInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_search_seniority(inputs)
	if (locale === "fr") return fr_salary_search_seniority(inputs)
	if (locale === "es") return es_salary_search_seniority(inputs)
	if (locale === "it") return it_salary_search_seniority(inputs)
	if (locale === "nl") return nl_salary_search_seniority(inputs)
	if (locale === "pl") return pl_salary_search_seniority(inputs)
	if (locale === "fi") return fi_salary_search_seniority(inputs)
	if (locale === "da") return da_salary_search_seniority(inputs)
	if (locale === "sv") return sv_salary_search_seniority(inputs)
	return en_salary_search_seniority(inputs)
});